/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next"

// components
import TextField from "@mui/material/TextField";
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { IconButton } from "@mui/material";
import SearchIcon from '../../../../assets/Search.svg'

// hooks
import usePreviousSearchText from "../../../../hooks/usePreviousSearchText"
import { useIsMobileView } from "../../../../utils/isMobileView";

// styles
import styles from './SearchBar.module.scss'

const SearchBar = ({ searchText, setSearchText, getBulkUploadStatuses }) => {
  const { t } = useTranslation()
  const isMobileView = useIsMobileView()
  const { previousSearchText, setPreviousSearchText } = usePreviousSearchText(searchText);
  const handleSearch = (e) => {
    const { value } = e?.target;
    setSearchText(value)
  };

  const canSearch =
    Boolean(searchText?.trim()) && searchText !== previousSearchText

  const handleSubmit = () => {
    if (canSearch) {
      setPreviousSearchText(searchText)
      getBulkUploadStatuses()
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && canSearch) {
      setPreviousSearchText(searchText)
      getBulkUploadStatuses()
    }
  }

  const containerClass = isMobileView
      ? styles.containerMobile
      : styles.containerDesktop
    const fieldClass = isMobileView
      ? styles.searchFieldMobile
      : styles.searchFieldDesktop
    const startAdornmentClass = isMobileView
      ? styles.startAdornmentMobile
      : styles.startAdornmentDesktop
    const searchIconClass = isMobileView
      ? styles.searchIconMobile
      : styles.searchIconDesktop
    const endActionsClass = isMobileView
      ? styles.endActionsMobile
      : styles.endActionsDesktop
    const clearBtnClass = isMobileView
      ? styles.clearBtnMobile
      : styles.clearBtnDesktop
    const submitBtnClass = isMobileView
      ? styles.submitBtnMobile
      : styles.submitBtnDesktop

  return (
    <div
      className={containerClass}
      style={{
        marginLeft: '80px',
        marginRight: '80px',
        marginBottom: '3px',
        backgroundColor: '#F5F5F5',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <TextField
        placeholder={t('bulk-search-bar-placeholder')}
        value={searchText}
        size="small"
        onChange={handleSearch}
        onKeyDown={handleKeyDown}
        style={{
          borderBottom: '1px solid #C1BBB3',
          paddingTop: '12px',
          paddingBottom: '11px',
        }}
        className={fieldClass}
        InputProps={{
          startAdornment: (
            <div className={startAdornmentClass} aria-hidden="true">
              <img src={SearchIcon} alt="" className={searchIconClass} />
            </div>
          ),
          endAdornment: (
            <div className={endActionsClass}>
              {searchText?.length > 0 && (
                <IconButton
                  aria-label={t('clear-search') || 'Clear search'}
                  onClick={() => setSearchText('')}
                  size="small"
                  className={clearBtnClass}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
              <button
                type="button"
                className={submitBtnClass}
                onClick={handleSubmit}
                disabled={!canSearch}
                aria-label={t('search') || 'Search'}
              >
                <ArrowForwardIcon fontSize="small" />
              </button>
            </div>
          ),
        }}
        sx={{
          width: '875px',
          padding: '10px 10px 10px 2px',
          border: '0px 0px 1px 0px',
          gap: '10px',
          backgroundColor: 'white',
          '& .MuiInputBase-input::placeholder': {
            color: '#564C47',
            opacity: 1,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
      />
    </div>
  );
};

export default SearchBar;
